import { roundToPlaces } from "../../utils/roundToPlaces.js";
import { Currency } from "../Currency.js";
import type { ExchangeRate } from "../ExchangeRatesSetting.js";

export function convertPriceInCzkToCurrency(
	priceInCzk: number,
	targetCurrency: Currency,
	exchangeRates: ExchangeRate[],
): number {
	if (targetCurrency === Currency.CZK) {
		return priceInCzk;
	}
	const exchangeRate = exchangeRates.find((rate) => rate.currency === targetCurrency);
	if (!exchangeRate) {
		throw new Error(`No exchange rate found for currency: ${targetCurrency}`);
	}
	return roundToPlaces(priceInCzk / exchangeRate.exchangeRate, 2);
}
